<div *ngIf="profileXpressUserRoleId !== 0"
    class="layout-topbar"
     [ngClass]="{
    'sidebar-active': app.sidebarActive,
    'topbar-sidebar-slim': (configService.config.menuMode === 'sidebar' && !(profileXpressUserRoleId | isMerchant)) || configService.config.menuMode === 'slim' && !(profileXpressUserRoleId | isMerchant),
    'topbar-sidebar-slim-merchant': (profileXpressUserRoleId | isMerchant),
    'topbar-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'topbar-bottom': configService.config.menuMode === 'horizontal'}">
    <div class="layout-topbar-wrapper"> 
        
        <menu (mouseenter)="menuComponent.app.onSidebarMouseOver()"
              [profile]="profile"
              [ngClass]="{'menu-hide': configService.config.menuMode === 'horizontal'}"
              style="display:contents">
        </menu>

        <div *ngIf="!isMerchant()" class="topbar-header">            
            <div class="topbar-header-title">{{isOperator() ? "Operator's" : 'Admin'}} Portal</div>
            <div class="topbar-header-sub-title">Private & Confidential. All actions are recorded.</div>                          
        </div>

        <div *ngIf="this.appData.isBoracayLocation">
            <img src="/Content/xpress-app/images/xpress_logo_boracay_black.png" style="height: 45px;" />
        </div>

        <div *ngIf="!isMerchant()" class="layout-topbar-right">
            <div class="filler"></div>

            <!-- Avatar -->
            <div *ngIf="!profile.ImageUrl" class="mt-1 xpress-topbar-avatar-empty">
                {{profile.FirstName | slice:0:1 | uppercase}}{{profile.LastName | slice:0:1 | uppercase}}
            </div>
            <div *ngIf="profile.ImageUrl">
                <img class="mt-1 xpress-topbar-avatar" src="{{profile.ImageUrl}}" />
            </div>

            <!-- Profile button -->
            <div class="ml-3 pi pi-angle-down cursor-pointer" data-testid="admin-header-profile-trigger" (click)="topbarActionsOverlay.toggle($event)"></div>

            <!-- Topbar actions overlay -->
            <p-overlayPanel #topbarActionsOverlay class="profile-panel">
                <ng-template pTemplate="content">
                    <div class="flex-row" style="margin-top: -8px;margin-bottom: -5px;">
                        <!-- Avatar -->
                        <div *ngIf="!profile.ImageUrl" class="mt-1 xpress-topbar-avatar-empty">
                            {{profile.FirstName | slice:0:1 | uppercase}}{{profile.LastName | slice:0:1 | uppercase}}
                        </div>
                        <div *ngIf="profile.ImageUrl">
                            <img class="mt-1 xpress-topbar-avatar" src="{{profile.ImageUrl}}" width="48" height="48" />
                        </div>
                        <!-- User name -->
                        <div class="ml-3 mt-1">
                            <div class="profile-font font-16 global-text-color">{{profile.FirstName}} {{profile.LastName}}</div>
                            <div class="profile-font font-14 global-text-color mt-3">{{XpressUserRoleEnum[+appData.authData.roleId]}}</div>
                        </div>
                    </div>

                    <hr class="xpress-topbar-actions-hr" />

                    <span [ngClass]="{'hidden': +appData.authData.roleId !== XpressUserRoleEnum.Operator}">
                        <div class="gray-area flex justify-content-between">
                            <div>
                                <div class="profile-font operator-code-color font-16">{{profile.OperatorCode}}</div>
                                <div class="profile-font code-type-color font-12 pr-7">Operator Code</div>
                            </div>
                            <img src="../Content/xpress-app/images/copy_blue.svg" class="mt-2 cursor-pointer" width="24" height="24" (click)="copyCode()" />
                        </div>
                        <hr class="xpress-topbar-actions-hr" />
                    </span>

                    <div>
                        <div class="flex ml-3 w-fit cursor-pointer" (click)="onProfileClick()">
                            <div class="mt-2 fw-6 scale-12 pi pi-user block"></div>
                            <div class="profile-font font-16 global-text-color ml-3 mt-1">My Profile</div>
                        </div>
                        <div class="mt-3 flex ml-3 w-fit cursor-pointer" (click)="onHelpCenterClick()">
                            <div class="mt-2 fw-6 scale-12 pi pi-question-circle"></div>
                            <div class="profile-font font-16 global-text-color ml-3 mt-1">Help Center</div>
                        </div>
                    </div>

                        <div *ngIf="appData.xpressUserRoleId === xpressUserRoleEnum.Merchant"
                             class="xpress-topbar-action"
                             (click)="onProvideAccessClick()">Provide Access to Xpress</div>

                    <hr class="xpress-topbar-actions-hr" />
                    <ng-container *ngIf="tiersEnabled">
                        <div class="gray-area flex">
                            <img src="../Content/xpress-app/images/bronze-tier.svg" width="33" height="36" />
                            <div class="ml-3 mg-auto-0 profile-font font-16" [ngStyle]="getTierStyle(tier)">{{tier}}</div>
                        </div>
                        <hr class="xpress-topbar-actions-hr" />
                    </ng-container>

                    <div class="flex ml-3 w-fit cursor-pointer" data-testid="admin-header-logout" (click)="logout()">
                        <div class="p-error scale-12"><div class="fw-5 mt-2 pi pi-sign-out"></div></div>
                        <div class="p-error ml-2 pl-1 mt-1 profile-font font-16">Logout</div>
                    </div>
                </ng-template>
            </p-overlayPanel>
        </div>
    </div>
</div>

<profile-detail *ngIf="showMyProfile" 
            (closed)="onMyProfileHide()"
            [profile]="profile"
            [initialProfile]="initialProfile"
            (profileChanged)="onProfileUpdate($event)"
            (hideProfile)="hideProfile($event)"
            ></profile-detail>

<partner-profile *ngIf="showPartnerProfilePopup"
                 [xpressUserRoleId]="profileXpressUserRoleId"
                 [userId]="profileUserId"
                 [onHide]="onPartnerProfilePopupHide"
                 [onSave]="onPartnerProfilePopupSave"></partner-profile>

<partner-provide-access *ngIf="showPartnerAccessPopup"
                        [onHide]="onPartnerAccessPopupHide"></partner-provide-access>

<p-toast position="top-right"></p-toast>
